import { InspectorPanelSettingsFields } from "../../InspectorPanelSettingsFields"
import * as Icons from "@nova/component-icons"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { ButtonPrimary } from "@nova/component-btn"
import { JobStatusType } from "@nova/constants"
import { selectVideoColorFinderFlightById } from "features/entity-caching/flights/selectors"
import { openColorFinder } from "plugins/ColorFinder/V2/redux/slice"

export const InspectorPanelVCFLayer = ({ id }: { id: string }) => {
    const dispatch = useAppDispatch()
    const flight = useAppSelector(selectVideoColorFinderFlightById(id))
    if (!flight) return null
    const videoExists = flight.job?.status === JobStatusType.COMPLETED

    return (
        <>
            <InspectorPanelSettingsFields shouldShowTopBorder={false}>
                {videoExists && (
                    <ButtonPrimary
                        title="View Color Data"
                        RightIcon={Icons.ArrowRight}
                        className="mb-2"
                        onClick={() => {
                            dispatch(openColorFinder({ flightId: id }))
                        }}
                    />
                )}
            </InspectorPanelSettingsFields>
        </>
    )
}
